import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import StarRating from '@/components/common/StarRating.vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import CourseProgressBar from '@/components/course/CourseProgressBar.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useCommonMixin from '@/composables/useCommonMixin'
  import useCourse from '@/composables/useCourse'
  import useSegment from '@/composables/useSegment'
  import { CourseModule } from '@/store/modules/course'
  import useIcons from '@/composables/useIcons'
  import CourseModuleDuration from '@/components/course/CourseModuleDuration.vue'
  import useBreakpoint from '@/composables/useBreakpoint'
  import { useRouter } from 'vue-router/composables'
  import type { CourseItem as CourseItemState } from '@/services/interfaces/Course'
  import eventBus from '@/main'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseItem',
  props: {
    course: {
      required: true,
      type: Object as () => CourseItemState,
    },
    discount: {
      type: Number,
      default: 0,
    },
    usedInUpsellModal: {
      type: Boolean,
      default: false,
    },
  },
  setup(__props) {

const props = __props;

  

  const router = useRouter()
  const { arrowRight, checkmark } = useIcons()
  const { courseItemClicked, courseUpsellModalShown } = useSegment()
  const { isMobileDevice } = useBreakpoint()
  const { completedModules, productPrice } = useCourse()
  const { currencyFormatDE } = useCommonMixin()

  const tags = computed(() => {
    return props.course.tags.map((t) => t.title).join(', ')
  })

  const discountValue = computed(() => {
    const amount = productPrice.value(props.course)
    return currencyFormatDE(amount + props.discount * amount)
  })

  const showCourseUpsellOrRouteToCourseInfo = async (state: string) => {
    await courseItemClicked(props.course.id, props.course.title, props.course.state, 'courses_page')
    if (state === 'ready') {
      eventBus.$emit('turn-on-loader')
      if (!CourseModule.coursesModuleMap[props.course.id]) {
        await CourseModule.getCourseModules(props.course.id)
      }
      await router.push({
        name: 'CourseDetails',
        params: { courseId: props.course.id, discount: String(props.discount) },
      })
      eventBus.$emit('turn-off-loader')
    } else {
      await courseUpsellModalShown(props.course.id, props.course.title, 'courses_page')
      eventBus.$emit('show-modal', {
        modalContentComponent: 'UpsellModal',
        cssClass: 'upsell',
        modalProps: {
          recommendedCourse: props.course,
          discount: props.discount,
        },
        modalCloseCallback: (callback: () => void) => {
          if (typeof callback === 'function') callback()
        },
      })
    }
  }

  const totalCourseGroupModules = computed(() => {
    const courseGroupsIds = props.course.courseGroups?.map((c) => c.id) || []
    return CourseModule.totalCourseGroupModules(props.course.id, courseGroupsIds)
  })

return { __sfc: true,props, router, arrowRight, checkmark, courseItemClicked, courseUpsellModalShown, isMobileDevice, completedModules, productPrice, currencyFormatDE, tags, discountValue, showCourseUpsellOrRouteToCourseInfo, totalCourseGroupModules, computed, StarRating, KetchUpButton, CourseProgressBar, SVGRenderer, useCommonMixin, useCourse, useSegment, CourseModule, useIcons, CourseModuleDuration, useBreakpoint, useRouter, eventBus }
}

})